document.addEventListener('DOMContentLoaded', () => {
  async function fetchProvince(cep) {
    const cleanedCep = cep.replace(/\D/g, '');
    
    // Lista de provedores de CEP por ordem de preferência
    // 1 - AwesomeAPI (Mais robusta, sem CORS issue)
    // 2 - OpenCEP (Super rápida baseada em Cloudflare)
    // 3 - ViaCEP (Clássica e confiável)
    // 4 - BrasilAPI v2 (Projeto open source confiável)
    const cepProviders = [
      {
        name: 'AwesomeAPI',
        fetcher: async (c) => {
          const res = await fetch(`https://cep.awesomeapi.com.br/json/${c}`);
          if (!res.ok) throw new Error('Falha na resposta Http');
          const data = await res.json();
          if (!data.state) throw new Error('Estado em branco');
          return data.state;
        }
      },
      {
        name: 'OpenCEP',
        fetcher: async (c) => {
          const res = await fetch(`https://opencep.com/v1/${c}`);
          if (!res.ok) throw new Error('Falha na resposta Http');
          const data = await res.json();
          if (!data.uf) throw new Error('Estado em branco');
          return data.uf;
        }
      },
      {
        name: 'ViaCEP',
        fetcher: async (c) => {
          const res = await fetch(`https://viacep.com.br/ws/${c}/json/`);
          if (!res.ok) throw new Error('Falha na resposta Http');
          const data = await res.json();
          if (data.erro) throw new Error('CEP não existe');
          if (!data.uf) throw new Error('Estado em branco');
          return data.uf;
        }
      },
      {
        name: 'BrasilAPI v2',
        fetcher: async (c) => {
          const res = await fetch(`https://brasilapi.com.br/api/cep/v2/${c}`);
          if (!res.ok) throw new Error('Falha na resposta Http');
          const data = await res.json();
          if (!data.state) throw new Error('Estado em branco');
          return data.state;
        }
      }
    ];

    // Dispara todas as requisições de CEP simultaneamente.
    // O Promise.any retorna a PRIMEIRA que der sucesso, o que garante velocidade máxima
    // e zero tempo de espera se uma delas for lenta ou estiver fora do ar.
    const cepRequests = cepProviders.map(provider => 
      provider.fetcher(cleanedCep).then(state => {
        return state;
      })
    );

    try {
      return await Promise.any(cepRequests);
    } catch (errors) {
      document.getElementById('shipping-result').innerHTML = 'Não foi possível identificar o estado. Verifique se o CEP está correto.';
      throw new Error('Falha generalizada nas APIs de CEP.');
    }
  }

  async function saveCartState() {
    const response = await fetch('/cart.js?t=' + Date.now());
    const state = await response.json();
    return state;
  }

  async function restoreCartState(cartState) {
    await fetch('/cart/clear.js', { method: 'POST' });

    if (cartState.items && cartState.items.length > 0) {
      const updates = {};
      cartState.items.forEach(item => {
        updates[item.variant_id] = item.quantity; 
      });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates })
      });
    }
  }

  async function clearCart() {
    await fetch('/cart/clear.js', { method: 'POST' });
  }

  const postalCodeInput = document.getElementById('postal-code');
  postalCodeInput.addEventListener('input', function() {
    this.value = this.value.replace(/\D/g, '');
  });

  postalCodeInput.addEventListener('change', function() {
    this.value = this.value.replace(/\D/g, '');
    if (this.value.length === 8) {
      this.value = this.value.replace(/^(\d{5})(\d{3})$/, "$1-$2");
    }
  });


  const shippingCalc = document.getElementById('shipping-calc');
  const productForm = document.querySelector('form.product-form');

  if (productForm) {
    productForm.addEventListener('change', function(event) {
      if (event.target.matches('input[type="radio"]')) {
        const variantIdElement = document.querySelector('#variant-id') || document.querySelector('form.product-form input[name="id"]');
        const variantId = variantIdElement ? variantIdElement.value : null;
        if (variantId) {
          shippingCalc.dataset.variantId = variantId;
        }
      }
    });
  }

  document.getElementById('calculate-shipping').addEventListener('click', async function() {
    const button = this;
    const postalCode = postalCodeInput.value.replace(/\D/g, '');
    const shippingCalc = document.getElementById('shipping-calc');
    const variantIdElement = document.querySelector('#variant-id') || document.querySelector('form.product-form input[name="id"]');
    const productVariantId = variantIdElement ? variantIdElement.value : shippingCalc.dataset.variantId;
    const quantityInput = document.querySelector('form.product-form input[name="quantity"]');
    const productQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;


    if (!productVariantId) {
      return;
    }

    button.classList.add('loading');
    button.disabled = true;

    if (postalCode.length !== 8) {
      document.getElementById('shipping-result').innerHTML = 'Por favor, insira um CEP válido.';
      button.classList.remove('loading');
      button.disabled = false;
      return;
    }

    try {
      
      // Salvar carrinho e buscar estado são processos independentes
      // Iniciar os dois JUNTOS corta o tempo de espera pela metade.
      const cartStatePromise = saveCartState();
      const provincePromise = fetchProvince(postalCode);

      // Espera salvar o carrinho primeiro antes de limpar
      const cartState = await cartStatePromise;
      await clearCart();
      
      // Garante que a província já chegou
      const province = await provincePromise;
      
      if (!province) {
        throw new Error('Não foi possível identificar o estado do CEP informado');
      }


      let items = [];
      const conjuntoContainer = document.querySelector('[data-product-conjunto]');
      const compreJuntoContainer = document.querySelector('[data-compre-junto]');

      if (conjuntoContainer) {
        // Caso 1: Conjunto
        const checkedBoxes = conjuntoContainer.querySelectorAll('.conjunto-product-checkbox-input:checked');
        checkedBoxes.forEach(checkbox => {
          const vId = checkbox.dataset.variantId || checkbox.dataset.fallbackVariantId;
          if (vId) {
            items.push({
              id: vId,
              quantity: 1
            });
          }
        });
      } else {
        // Caso 2: Produto Normal
        items.push({
          id: productVariantId,
          quantity: productQuantity
        });

        if (compreJuntoContainer) {
          const selectedUpsells = compreJuntoContainer.querySelectorAll('.compre-junto-checkbox:checked');
          selectedUpsells.forEach(cb => {
            if (cb.dataset.productId) {
              items.push({
                id: cb.dataset.productId,
                quantity: 1
              });
            }
          });
        }
      }

      
      const addToCartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });
      
      const addToCartData = await addToCartResponse.json();
      if (addToCartData.errors) {
        throw new Error(`Erro ao preparar cálculo: ${addToCartData.description || 'Produto indisponível'}`);
      }

      // Remover atraso artificial! Agora as tentativas já cobrem delay orgânico,
      // tornando possível o frete retornar em ~150ms se o servidor Shopify for rápido.
      
      async function fetchShippingRatesWithRetry(startTime = Date.now(), attempt = 1) {
        const maxTime = 12000;
        const currentTime = Date.now();
        const elapsedTime = currentTime - startTime;
        if (elapsedTime >= maxTime) {
          return { rates: [], data: { shipping_rates: [] } };
        }
        
        const timestamp = Date.now();
        const randomHash = Math.random().toString(36).substring(7);
        const shippingUrl = `/cart/shipping_rates.json?shipping_address[zip]=${postalCode}&shipping_address[country]=BR&shipping_address[province]=${province}&_t=${timestamp}&_h=${randomHash}`;
        
        
        const response = await fetch(shippingUrl);
        const data = await response.json();
        const rates = data.shipping_rates;
        
        const hasNoRates = !rates || rates.length === 0;
        const hasOnlyLocalDelivery = rates && rates.length === 1 && rates[0]?.name === 'Local Delivery';
        const shouldRetry = hasNoRates || hasOnlyLocalDelivery;
        
        if (shouldRetry) {
          // Começa com esperas mais curtas nas primeiras tentativas para não punir respostas que seriam quase instantâneas
          const waitTime = attempt === 1 ? 400 : Math.min(600 + (attempt * 100), 1500);
          await new Promise(resolve => setTimeout(resolve, waitTime));
          return fetchShippingRatesWithRetry(startTime, attempt + 1);
        }
        
        return { rates, data };
      }
      
      const { rates, data } = await fetchShippingRatesWithRetry();
      
      
      
      if (!rates || rates.length === 0) {
        document.getElementById('shipping-result').innerHTML = 'Não conseguimos obter o frete exato agora, mas você poderá consultar o valor final no checkout.';
        document.getElementById('shipping-result').classList.add('active');
        await restoreCartState(cartState);
        button.classList.remove('loading');
        button.disabled = false;
        return;
      }
      
      
      
      // Calculate fastest and cheapest rates
      let cheapestRate = null;
      let fastestRate = null;
      let minPrice = Infinity;
      let minDays = Infinity;

      rates.forEach(rate => {
        const price = parseFloat(rate.price);
        const days = window.ShippingDeliveryDays
          ? window.ShippingDeliveryDays.getComparisonDays(rate)
          : (rate.name === 'Local Delivery' ? 1 : (rate.delivery_days && rate.delivery_days[0] ? rate.delivery_days[0] : 999));

        if (price < minPrice) {
          minPrice = price;
          cheapestRate = rate;
        }
        if (days < minDays) {
          minDays = days;
          fastestRate = rate;
        }
      });

      let resultHtml = '<ul>';
      
  

      
      rates.forEach((rate, index) => {
        const priceValue = parseFloat(rate.price);
        const priceText = (priceValue === 0) ? 'Grátis' : `R$ ${priceValue.toFixed(2).replace('.', ',')}`;
        const displayName = rate.name === 'Local Delivery' ? 'Entrega Motoboy' : rate.name;
        
        const isCheapest = rate === cheapestRate && priceValue > 0;
        const isFastest = rate === fastestRate;

        let flagsHtml = '';
        if (isFastest) flagsHtml += '<span class="shipping-flag">Mais rápido</span>';
        if (isCheapest && minPrice > 0) flagsHtml += '<span class="shipping-flag">Mais barato</span>';

        let deliveryDays = '';
        if (window.ShippingDeliveryDays) {
          deliveryDays = window.ShippingDeliveryDays.formatDeliveryText(rate, displayName);
        } else if (displayName === 'Entrega Motoboy') {
          deliveryDays = '1 dia útil';
        } else if (rate.delivery_days && rate.delivery_days[0]) {
          const daysVal = rate.delivery_days[0];
          const dayText = daysVal === 1 ? 'dia útil' : 'dias úteis';
          deliveryDays = `${daysVal} ${dayText} após o envio`;
        } else if (displayName !== 'Entrega Motoboy') {
          deliveryDays = 'Prazo a consultar';
        }

        resultHtml += `
          <li class="shipping-list-item">
            <div class="method">
              <div class="method-info">
                ${displayName} ${flagsHtml}
              </div>
              <span class="price">${priceText}</span>
            </div>
            ${deliveryDays ? `<div class="prazo">${deliveryDays}</div>` : ''}
          </li>`;
      });
      
      resultHtml += '</ul>';
  
      document.getElementById('shipping-result').innerHTML = resultHtml;
      document.getElementById('shipping-result').classList.add('active');

      await restoreCartState(cartState);
      button.classList.remove('loading');
      button.disabled = false;
    } catch (error) {
      document.getElementById('shipping-result').innerHTML = 'Ocorreu um problema temporário. Tente calcular novamente ou finalize no checkout.';
      document.getElementById('shipping-result').classList.add('active');
      
      const cartState = await saveCartState();
      await restoreCartState(cartState);
      button.classList.remove('loading');
      button.disabled = false;
    }
  });
});
